export enum WidgetsTypesEnum {
  // Purchases
  lastOrders = 'last-orders',
  purchasesScheduledPendents = 'purchases-scheduled-pendents',
  notReceivedOrders = 'not-received-orders',
  notSentOrders = 'not-sent-orders',

  // Warehouse
  pendentsTransfers = 'pendents-transfers',
  inventoryScheduledPendents = 'inventory-scheduled-pendents',

  // RRHH
  lastClockIn = 'last-clock-in',

  // Finances
  ebitdaIncome = 'ebitda-income',
  ebitdaReport = 'ebitda-report',
  ebitdaPurchases = 'ebitda-purchases',
  ebitdaPersonal = 'ebitda-personal',
  ebitdaGeneral = 'ebitda-general',

  // Documents review
  documentsReview = 'documents-review',
  deliveryNotesReview = 'delivery-notes-review',
  expensesReview = 'expenses-review',
  payrollsReview = 'payrolls-review',
  unclassifiedReview = 'unclassified-review',

  // Communication
  unreadCommunication = 'unread-communication',
  pendentsBreakdowns = 'pendents-breakdowns',

  // Tasks
  completedChecklists = 'completed-checklists',
  completedAppcc = 'completed-appcc',
  completedAudit = 'completed-audit',
  valuationAudit = 'audit-valuation',
}
